module.exports = __webpack_public_path__ + "img/logo.6a90b6c1.png";